"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _constants = require("../../../assets/js/constants");

var _wideContainer = require("../wideContainer");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MODE_WIDE = 'wide';
var MODE_DEFAULT = 'default';
/**
 * Получает отступы
 * @param {Object} config
 * @param {number} config.value
 * @param {boolean} [config.fullwidth]
 */

var getPadding = function getPadding(_ref) {
  var value = _ref.value,
      fullwidth = _ref.fullwidth;
  var padding = fullwidth ? '0' : "".concat(value, "px");
  return (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        padding-left: ", ";\n        padding-right: ", ";\n    "])), padding, padding);
};

var Container = _styledComponents["default"].div.withConfig({
  displayName: "gridContainer__Container",
  componentId: "sc-1crbr81-0"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-left: auto;\n    margin-right: auto;\n    ", "\n\n    ", "\n"])), function (_ref2) {
  var fullwidth = _ref2.fullwidth;
  return getPadding({
    value: _constants.layoutIndent,
    fullwidth: fullwidth
  });
}, function (p) {
  return p.modeName === MODE_WIDE ? (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            width: 1568px;\n\n            @media (max-width: ", ") {\n                width: 1280px;\n            }\n\n            @media (max-width: ", ") {\n                width: 1000px;\n            }\n\n            @media (max-width: ", ") {\n                ", "\n                width: 768px;\n            }\n\n            @media (max-width: ", ") {\n                width: 100%;\n            }\n\n            @media (max-width: ", ") {\n                ", "\n            }\n        "])), _wideContainer.wideBreakpoints.sDesktop, _wideContainer.wideBreakpoints.laptop, _wideContainer.wideBreakpoints.tablet, function (_ref3) {
    var fullwidth = _ref3.fullwidth;
    return getPadding({
      value: _constants.layoutIndent / 2,
      fullwidth: fullwidth
    });
  }, _wideContainer.wideBreakpoints.mobile, _wideContainer.wideBreakpoints.sMobile, function (_ref4) {
    var fullwidth = _ref4.fullwidth;
    return getPadding({
      value: _constants.layoutIndent / 4,
      fullwidth: fullwidth
    });
  }) : (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            width: ", "px;\n\n            @media(", ") {\n                width: ", "px;\n            }\n\n            @media(", ") {\n                width: ", "px;\n            }\n\n            @media(", ") {\n                width: 94.221%;\n                min-width: ", "px;\n            }\n\n            @media(", ") {\n                ", "\n                width: 98.594%;\n                min-width: 320px;\n            }\n        "])), 1360 + _constants.layoutIndent * 2, (0, _constants.breakPoint)(1366, MODE_DEFAULT), 1032 + _constants.layoutIndent * 2, (0, _constants.breakPoint)(1024, MODE_DEFAULT), 800 + _constants.layoutIndent * 2, (0, _constants.breakPoint)(768, MODE_DEFAULT), 592 + _constants.layoutIndent * 2, (0, _constants.breakPoint)(320, MODE_DEFAULT), function (_ref5) {
    var fullwidth = _ref5.fullwidth;
    return getPadding({
      value: _constants.layoutIndent / 2,
      fullwidth: fullwidth
    });
  });
});
/**
 * @deprecated
 * Использовать новый компонент сетки src/components/layouts/wideContainer
 * */


var Component = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(Container, _extends({
    ref: ref
  }, props));
});
Component.displayName = 'ForwardedComponent';
var _default = Component;
exports["default"] = _default;